export default __webpack_public_path__ + "451dcf3e0e6469e8c03adc79709e47ce.svg";